import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { KeyRound, LogOut } from "lucide-react";
import { toast } from "sonner";

const inp = "w-full bg-white border border-slate-200 rounded-lg px-3 py-2.5 text-sm text-slate-900 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500/40";

function Shell({ icon, title, sub, children }) {
  const { logout } = useAuth();
  const { t } = useI18n();
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-4" data-testid="security-gate">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-lg overflow-hidden">
        <div className="bg-blue-700 px-6 py-5 text-white flex items-center gap-3">
          {icon}
          <div><div className="text-[10px] font-mono uppercase tracking-wider opacity-80">BVD-Ituri · {t("sg_security")}</div>
            <div className="font-head font-bold text-lg">{title}</div></div>
        </div>
        <div className="p-6">
          <p className="text-sm text-slate-500 mb-4">{sub}</p>
          {children}
          <button data-testid="gate-logout" onClick={logout} className="mt-5 w-full flex items-center justify-center gap-2 text-xs font-semibold text-slate-500 hover:text-slate-800">
            <LogOut className="w-3.5 h-3.5" /> {t("logout")}
          </button>
        </div>
      </div>
    </div>
  );
}

function ChangePassword({ onDone }) {
  const { t } = useI18n();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (pw !== pw2) { toast.error(t("sg_pw_mismatch")); return; }
    setBusy(true);
    try { await api.post("/auth/change-password", { new_password: pw }); toast.success(t("sg_pw_updated")); onDone(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Shell icon={<KeyRound className="w-6 h-6" />} title={t("sg_pw_required")}
      sub={t("sg_pw_sub")}>
      <div className="space-y-3">
        <input data-testid="gate-new-password" type="password" placeholder={t("sg_new_pw")} className={inp} value={pw} onChange={(e) => setPw(e.target.value)} />
        <input data-testid="gate-new-password2" type="password" placeholder={t("sg_confirm_pw")} className={inp} value={pw2} onChange={(e) => setPw2(e.target.value)} />
        <button data-testid="gate-change-submit" onClick={submit} disabled={busy} className="w-full bg-blue-700 hover:bg-blue-600 disabled:opacity-60 text-white font-semibold py-2.5 rounded-lg">{t("sg_save_continue")}</button>
      </div>
    </Shell>
  );
}

export default function SecurityGate() {
  const { refresh } = useAuth();
  return <ChangePassword onDone={() => refresh()} />;
}
